// this file is automatically generated by version.sh script
export const version: Version = {
  version: '2.16.21',
  revision: 'dfde304cb',
  branch: 'master',
  timestamp: '30.07.2025'
};

export interface Version {
  revision: string;
  version: string;
  branch: string;
  timestamp: string;
}
